import { render } from "./Draggable.vue?vue&type=template&id=43776b52"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"

import "./Draggable.vue?vue&type=style&index=0&id=43776b52&lang=scss"
script.render = render

export default script